export const getAffOfferIdFromUrl = (referralUrl?: string): string => {
  if (!referralUrl) {
    return '';
  }

  try {
    const url = new URL(referralUrl);
    const params = new URLSearchParams(url.search);
    return params.get('aff_offer_id') || '';
  } catch {
    return '';
  }
};
